import { FAREWILL_API_URL } from 'config'

export const GET_POLICIES_ENDPOINT = `${FAREWILL_API_URL}/public/policies`
export const GET_VOUCHER_ENDPOINT = `${FAREWILL_API_URL}/public/find-user-by-voucher`
